import { render, staticRenderFns } from "./changelog.vue?vue&type=template&id=55b75a32&lang=pug&"
import script from "./changelog.vue?vue&type=script&lang=coffee&"
export * from "./changelog.vue?vue&type=script&lang=coffee&"
import style0 from "./changelog.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports